/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon16Solid = forwardRef('MoneyCurrencyRubleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.75 10H7v1h3a1 1 0 1 1 0 2H7v1a1 1 0 0 1-2 0v-1H4a1 1 0 0 1 0-2h1v-1H4a1 1 0 1 1 0-2h1V3.5A1.5 1.5 0 0 1 6.5 2h3.25a4 4 0 0 1 0 8ZM7 8V4h2.75a2 2 0 1 1 0 4H7Z" })));
});
